import { Typography } from '@mui/material';
import React from 'react';
import { InLine } from '../../../../cards/playerCards/CardDimensions';

export const CommentaryTypographyProps = {
  component: 'div',
  sx: {
    fontSize: InLine.playerNameFontSize,
    paddingLeft: InLine.playerNameBackgroundPadding,
  },
};
export const CommentaryTypography = (props: { children: React.ReactNode }) => {
  return (
    <Typography {...CommentaryTypographyProps}> {props.children}</Typography>
  );
};
